import { eventChannel } from 'redux-saga';
import { all, takeEvery, fork, take, put } from 'redux-saga/effects';
import { isNil, prop, unless, evolve } from 'ramda';

import { ItineraryActions, ItineraryTypes } from './itinerary.redux';
import { UserTypes } from '../user';
import { bookingsRef, firebaseFunctions } from '../../shared/services/firebase';
import reportError from '../../shared/utils/reportError';
import { SnackbarActions } from '../snackbar';
import { SNACKBAR_CANCEL_BOOKING_SUCCESS } from '../snackbar/snackbar.constants';

const createItineraryChannel = bookingRef =>
  eventChannel(emitter => {
    const onValueReceived = snapshot => {
      const value = snapshot.val();
      setTimeout(() => unless(isNil, emitter)(value));
    };

    bookingRef.on('value', onValueReceived);
    return () => bookingRef.off('value', onValueReceived);
  });

function* watchChanges(bookingId) {
  const bookingRef = bookingsRef.child(bookingId);
  const listenForUserBookings = yield createItineraryChannel(bookingRef);

  while (true) {
    const data = yield take(listenForUserBookings);
    const experience = prop('experience')(data);

    const parsedExperience = evolve({
      heroGallery: JSON.parse,
      refund: evolve({ timePeriods: JSON.parse }),
    })(experience);

    yield put(ItineraryActions.setItem({ bookingId, ...data, experience: { ...parsedExperience } }));
  }
}

function* startWatchingChanges({ bookingId }) {
  yield fork(watchChanges, bookingId);
}

function* cancelBooking({ bookingId }) {
  try {
    yield firebaseFunctions.post('/cancelBooking/', { bookingId });
    yield put(ItineraryActions.hideModal());
    yield put(ItineraryActions.cancelBookingSuccess(bookingId));
    yield put(SnackbarActions.showSnackbar(SNACKBAR_CANCEL_BOOKING_SUCCESS));
  } catch (e) {
    yield put(ItineraryActions.cancelBookingFailure(bookingId));
    reportError(e);
  }
}

export default function* startupSaga() {
  yield all([
    takeEvery(UserTypes.BOOKING_ADDED, startWatchingChanges),
    takeEvery(ItineraryTypes.CANCEL_BOOKING, cancelBooking),
  ]);
}
